import React, { useEffect } from 'react';
import { Alert } from '@thecb/components';
import { clearSharedAlerts, deleteSharedAlert } from '../../state/shared';
import { useDispatch, useSelector } from 'react-redux';
import { AlertBarWrapper, AlertBarContainer } from './AlertBar';
import { genRandomString } from '../../utils/helpers';

export const SharedAlertBar = ({
  isToast = false,
  alertClearTimeout = 10000,
  showQuitLink,
}) => {
  const dispatch = useDispatch();
  const { alerts: sharedAlerts } = useSelector((state) => state.shared);
  useEffect(() => () => dispatch(clearSharedAlerts()), []);
  useEffect(() => {
    if (isToast) {
      let timeout = setTimeout(() => {
        dispatch(clearSharedAlerts());
      }, alertClearTimeout);
      return () => clearTimeout(timeout);
    }
  }, []);

  return (
    <AlertBarWrapper>
      <AlertBarContainer position={isToast ? 'absolute' : 'static'}>
        {sharedAlerts.map((alert, i) => (
          <Alert
            showQuitLink={showQuitLink}
            themeValues={{ background: alert.background, border: alert.border }}
            key={genRandomString(alert.heading)}
            alertPosition={i}
            {...alert}
            onLinkClick={() => dispatch(deleteSharedAlert(i))}
          />
        ))}
      </AlertBarContainer>
    </AlertBarWrapper>
  );
};

export default SharedAlertBar;
